/**
 * Static-translations for uk. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const uk = {
  'anon.description_default': 'Налаштовуємо гостьовий сеанс…',
  'anon.heading_default': 'Продовжити як гість',
  'anon.try_again': 'Спробувати ще раз',
  'auth.back_to_login': 'Назад до входу',
  'auth.check_email_message': 'Перевірте пошту — ми надіслали код підтвердження.',
  'auth.check_email_title': 'Перевірте пошту',
  'auth.confirm_email_subtitle': 'Введіть код, який ми надіслали на вашу пошту, щоб завершити реєстрацію.',
  'auth.confirm_email_title': 'Підтвердіть пошту',
  'auth.confirmation_code': 'Код підтвердження',
  'auth.continue_with_apple': 'Продовжити через Apple',
  'auth.continue_with_facebook': 'Продовжити через Facebook',
  'auth.continue_with_github': 'Продовжити через GitHub',
  'auth.continue_with_google': 'Продовжити через Google',
  'auth.create_account': 'Створити акаунт',
  'auth.default_subtitle': 'Увійдіть для доступу до всіх функцій та синхронізації даних.',
  'auth.email': 'Електронна пошта',
  'auth.email_already_registered': 'Цей email уже зареєстровано. Увійдіть нижче — паролем або акаунтом, через який реєструвалися.',
  'auth.email_exists': 'Акаунт із таким email уже існує.',
  'auth.email_not_confirmed': 'Спочатку підтвердьте email.',
  'auth.forgot_password': 'Забули пароль?',
  'auth.forgot_password_title': 'Забули пароль?',
  'auth.forgot_subtitle': 'Введіть email, ми надішлемо посилання для скидання пароля.',
  'auth.generic_error': 'Щось пішло не так',
  'auth.have_account': 'Вже є обліковий запис?',
  'auth.hide_password': 'Сховати пароль',
  'auth.identity_already_linked': 'Цей акаунт уже зареєстровано. Увійдіть до нього нижче.',
  'auth.invalid_credentials': 'Невірний email або пароль',
  'auth.invalid_otp': 'Код недійсний або прострочений.',
  'auth.last_used': 'Останній вхід · {email}',
  'auth.last_used_no_email': 'Останній вхід',
  'auth.link_purchase_subheading': 'Прив\'яжемо покупку до акаунта, щоб доступ зберігся.',
  'auth.log_in': 'Увійти',
  'auth.log_in_link': 'Увійти',
  'auth.login_continue_purchase': 'Увійдіть, щоб продовжити покупку',
  'auth.network_error': 'Помилка мережі. Перевірте підключення та спробуйте ще раз.',
  'auth.no_account': 'Немає облікового запису?',
  'auth.or': 'або',
  'auth.password': 'Пароль',
  'auth.passwords_mismatch': 'Паролі не збігаються',
  'auth.rate_limited': 'Забагато запитів. Спробуйте пізніше.',
  'auth.repeat_password': 'Повторіть пароль',
  'auth.reset_link_valid': 'Посилання дійсне 1 годину.',
  'auth.reset_password_subtitle': 'Введіть код з листа і новий пароль.',
  'auth.reset_password_title': 'Скидання пароля',
  'auth.reset_sent_message': 'Якщо такий email існує, код для скидання надіслано.',
  'auth.reset_sent_subtitle': 'Ми надіслали посилання для скидання пароля. Дотримуйтесь інструкцій у листі.',
  'auth.restore_purchases_heading': 'Відновити покупки',
  'auth.restore_purchases_subheading': 'Увійдіть, щоб відновити покупки.',
  'auth.send_reset': 'Надіслати лист для скидання',
  'auth.service_unavailable': 'Сервіс тимчасово недоступний. Спробуйте пізніше.',
  'auth.show_password': 'Показати пароль',
  'auth.sign_out': 'Вийти',
  'auth.sign_up': 'Зареєструватися',
  'auth.sign_up_link': 'Зареєструватися',
  'auth.signed_in': 'Ви увійшли',
  'auth.signin_failed': 'Не вдалося увійти',
  'auth.signup_failed': 'Реєстрація не вдалася',
  'auth.verify': 'Підтвердити',
  'auth.weak_password': 'Надто слабкий пароль.',
  'auth.welcome': 'Ласкаво просимо!',
  'auth.welcome_signup': 'Ласкаво просимо!',
  'countdown.d': 'д',
  'countdown.h': 'г',
  'countdown.m': 'хв',
  'countdown.s': 'с',
  'cta.close': 'Закрити',
  'cta.continue': 'Продовжити',
  'cta.get_lifetime_access': 'Купити назавжди',
  'cta.get_plan_daily': 'Купити денний тариф',
  'cta.get_plan_generic': 'Купити {interval} тариф',
  'cta.get_plan_monthly': 'Купити місячний тариф',
  'cta.get_plan_weekly': 'Купити тижневий тариф',
  'cta.get_plan_yearly': 'Купити річний тариф',
  'cta.start_trial': 'Почати {days}-денний пробний період',
  'modal.close_aria': 'Закрити',
  'modal.continue': 'Продовжити',
  'modal.error_generic': 'Щось пішло не так',
  'modal.loading': 'Завантаження…',
  'modal.purchase_restored_subtitle': 'Усе готово — користуйтеся!',
  'modal.purchase_restored_title': 'Із поверненням',
  'modal.purchase_success_subtitle': 'Усе готово — користуйтеся!',
  'modal.purchase_success_title': 'Платіж отримано',
  'modal.verifying_subscription': 'Перевіряємо підписку…',
  'nav.back': '← Назад',
  'nav.back_aria': 'Назад',
  'offer.limited_time': 'Обмежена пропозиція',
  'payment.awaiting_subtitle': 'Ми визначимо оплату автоматично — або натисніть кнопку, коли закінчите.',
  'payment.awaiting_title': 'Очікування оплати...',
  'payment.checking': 'Перевіряємо…',
  'payment.ive_paid': 'Я сплатив',
  'payment.open_checkout_again': 'Відкрити оплату знову',
  'payment.open_checkout_button': 'Відкрити оплату',
  'payment.popup_blocked_message': 'Браузер заблокував вкладку з оплатою. Натисніть нижче, щоб відкрити її.',
  'payment.popup_blocked_title': 'Дозвольте спливаючі вікна, щоб продовжити',
  'payment.popup_help_text': 'Вікно оплати не відкрилося або заблоковане? Натисніть тут, щоб відкрити знову.',
  'payment.still_processing': 'Платіж ще обробляється. Спробуйте ще раз за мить.',
  'payment.tab_closed_retry': 'Закрили вкладку? Спробуйте знову',
  'pricing.free_trial_days': '{days}-денний безкоштовний пробний період',
  'pricing.included_per': 'Включено за {interval}:',
  'pricing.interval.day': 'день',
  'pricing.interval.lifetime_short': 'назавжди',
  'pricing.interval.month': 'місяць',
  'pricing.interval.period': 'період',
  'pricing.interval.week': 'тиждень',
  'pricing.interval.year': 'рік',
  'pricing.money_back': '30-денна гарантія повернення коштів',
  'pricing.most_popular': 'Найпопулярніший',
  'pricing.no_prices': 'Тарифів немає.',
  'pricing.plan_label.daily': 'ЩОДЕННИЙ ТАРИФ',
  'pricing.plan_label.lifetime': 'назавжди',
  'pricing.plan_label.monthly': 'щомісячний тариф',
  'pricing.plan_label.weekly': 'щотижневий тариф',
  'pricing.plan_label.yearly': 'щорічний тариф',
  'pricing.plans_aria': 'Тарифи',
  'session.contact_support': 'Звернутися до підтримки',
  'session.restore_purchases': 'Відновити покупки',
  'session.sign_out': 'Вийти',
  'session.signed_in_as_prefix': 'Ви увійшли як',
  'session.signing_out': 'Вихід…',
  'support.attachments_aria': 'Завантаження вкладень',
  'support.attachments_label': 'Вкладення',
  'support.close_button': 'Закрити',
  'support.done_button': 'Готово',
  'support.dropzone_text': 'Перетягніть зображення сюди або клацніть для вибору',
  'support.email_placeholder': 'Введіть email',
  'support.file_requirements': 'JPEG/PNG/WebP, до {max} файлів, ≤ {size} МБ кожен',
  'support.heading': 'Підтримка',
  'support.instruction': 'Заповніть форму нижче для надсилання запиту в підтримку.',
  'support.invalid_email': 'Некоректний email',
  'support.invalid_file': 'Лише JPEG/PNG/WebP, ≤ {size} МБ кожен',
  'support.message_length': '1–5000 символів',
  'support.message_placeholder': 'Введіть повідомлення',
  'support.remove_file_aria': 'Видалити {filename}',
  'support.required': 'Обов\'язково',
  'support.send_another': 'Надіслати ще запит',
  'support.send_button': 'Надіслати',
  'support.sending': 'Надсилання…',
  'support.sending_as': 'Надсилання від',
  'support.subject_length': '3–200 символів',
  'support.subject_placeholder': 'Введіть тему',
  'support.success_heading': 'Запит надіслано',
  'support.success_message_prefix': 'Ми отримали ваше повідомлення та відповімо на',
  'support.too_many_files': 'До {max} файлів'
} as const;

export default uk;
